// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__24kHD","additionalInfo":"AgreementModal_additionalInfo__1zE95"};